var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21457_140478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1356 49.9254C42.556 49.9254 52.6247 39.8567 52.6247 27.4364C52.6247 15.016 42.556 4.94727 30.1356 4.94727C17.7152 4.94727 7.64648 15.016 7.64648 27.4364C7.64648 39.8567 17.7152 49.9254 30.1356 49.9254Z",
    stroke: "#2D6CDF",
    strokeWidth: 4.49782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1353 4.94727C24.3606 11.0107 21.1396 19.0631 21.1396 27.4364C21.1396 35.8096 24.3606 43.862 30.1353 49.9254C35.91 43.862 39.1309 35.8096 39.1309 27.4364C39.1309 19.0631 35.91 11.0107 30.1353 4.94727Z",
    stroke: "#2D6CDF",
    strokeWidth: 4.49782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64648 27.4316H52.6247",
    stroke: "#2D6CDF",
    strokeWidth: 4.49782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21457_140478",
    x: -2.24845,
    y: -2.25533,
    width: 64.7684,
    height: 64.7694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.69869
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.69869
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21457_140478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21457_140478",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/internet.36603ff21304d8f9f512d71af6e73d05.svg";
export { ForwardRef as ReactComponent };